import Grid from "@mui/material/Grid";
import {FormHelperText, InputLabel, MenuItem, Select, TextField} from "@mui/material";
import Button from "@mui/material/Button";
import {Add, Save} from "@mui/icons-material";
import * as React from "react";
import payouts from "../../models/payouts";

export default function PayoutForm ({payoutMethods, fields, errors, handleChange, handleBlur, handleSubmit}) {
    return <React.Fragment>
        <Grid container spacing={2}
              component="form"
              onSubmit={handleSubmit}
              autoComplete="off"
        >
            <Grid size={{ xs: 12, md: 3 }}>
                <InputLabel>Method</InputLabel>
                <Select
                    fullWidth={true}
                    error={!!errors.method_id}
                    required={true}
                    name="method_id"
                    id="method_id"
                    value={fields.method_id || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    {
                        payoutMethods.map((method) => {
                            return <MenuItem key={`id-${method.id}`} value={method.id}>{`${method.name} - fee ${method.fee}%`}</MenuItem>
                        })
                    }
                </Select>
                {errors.method_id && <FormHelperText>{errors.method_id}</FormHelperText>}
            </Grid>
            <Grid size={{ xs: 6, md: 3 }}>
                <InputLabel>Amount</InputLabel>
                <TextField
                    error={!!errors.amount_total}
                    value={fields.amount_total || ""}
                    name="amount_total"
                    id="amount_total"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.amount_total && <FormHelperText>{errors.amount_total}</FormHelperText>}
            </Grid>
            {!fields.id && <Grid size={{ xs: 12, md: 6 }}>
                <InputLabel>Wallet Address</InputLabel>
                <TextField
                    error={!!errors.wallet_address}
                    value={fields.wallet_address || ""}
                    name="wallet_address"
                    id="wallet_address"
                    required={true}
                    fullWidth={true}
                    placeholder="Enter wallet address"
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.wallet_address && <FormHelperText>{errors.wallet_address}</FormHelperText>}
            </Grid>}
            {fields.id && <Grid size={{ xs: 6, md: 3 }}>
                <InputLabel>Net Amount</InputLabel>
                <TextField
                    error={!!errors.amount}
                    value={fields.amount || ""}
                    name="amount"
                    id="amount"
                    required={true}
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.amount && <FormHelperText>{errors.amount}</FormHelperText>}
            </Grid>}
            {fields.id && <Grid size={{ xs: 12, md: 3 }}>
                <InputLabel>Status</InputLabel>
                <Select
                    fullWidth={true}
                    error={!!errors.status}
                    required={true}
                    name="status"
                    id="status"
                    value={fields.status || ""}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    {
                        payouts.getStatuses().map((status) => {
                            return <MenuItem key={`status-${status}`} value={status}>{status}</MenuItem>
                        })
                    }
                </Select>
                {errors.status && <FormHelperText>{errors.status}</FormHelperText>}
            </Grid>}
            {fields.id && <Grid size={12}>
                <InputLabel>Wallet Address</InputLabel>
                <TextField
                    error={!!errors.wallet_address}
                    value={fields.wallet_address || ""}
                    name="wallet_address"
                    id="wallet_address"
                    size="small"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    InputProps={{
                        readOnly: true
                    }}
                />
                {errors.wallet_address && <FormHelperText>{errors.wallet_address}</FormHelperText>}
            </Grid>}
            {fields.id && <Grid size={12}>
                <InputLabel>Details</InputLabel>
                <TextField
                    error={!!errors.details}
                    value={fields.details || ""}
                    name="details"
                    id="details"
                    size="small"
                    fullWidth={true}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                {errors.details && <FormHelperText>{errors.details}</FormHelperText>}
            </Grid>}
            <Grid container spacing={3} sx={{mt: 2}} size={12}>
                <Grid size={{ xs: 6 }}>
                    <Button type="submit" onClick={handleSubmit} variant="outlined" startIcon={fields.id ? <Save /> : <Add />} >
                        {fields.id ? 'Save' : 'Submit'}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    </React.Fragment>
}
